/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parameter_Start_In_The_PastInputs */

const en_parameter_start_in_the_past = /** @type {(inputs: Parameter_Start_In_The_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Must be now or later`)
};

/**
* | output |
* | --- |
* | "Must be now or later" |
*
* @param {Parameter_Start_In_The_PastInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const parameter_start_in_the_past = /** @type {((inputs?: Parameter_Start_In_The_PastInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parameter_Start_In_The_PastInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_parameter_start_in_the_past(inputs)
});